<template lang="html">
  <div>
    <v-tooltip bottom v-if="tooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click.stop="dialog = true" :class="btnclass" color="red" v-on="on" v-bind="attrs" icon >
          <v-icon>delete</v-icon>
        </v-btn>
      </template>
      <span>{{tooltip}}</span>
    </v-tooltip>
    <v-btn v-else @click.stop="dialog = true" :class="btnclass" color="red" icon >
      <v-icon>delete</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('Buttons.Delete')}}</span>
        </v-card-title>
        <v-card-text>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">{{$t('Buttons.Close')}}</v-btn>
          <v-btn color="blue darken-1" text @click="closeDialogEmitEvent()">{{$t('Buttons.Delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
  name: 'StandardDeleteBtn',
  props: ['el', 'btnclass', 'tooltip'],
  data: function () {
    return {
      dialog: false
    }
  },
  methods: {
    closeDialogEmitEvent(){
      this.$emit('deleteClick', this.el);
      this.dialog = false;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
